<wiz-h-divider width="100%" height="100%" gap="0" padding="5px">
  <!-- panneau gauche -->
    <!-- panneau gauche -->
    <wiz-vgroup width="300px" minWidth="0px" maxWidth="300px" height="100%">

      <multi-display #multiDisp width="100%" height="100%" [config]="multiDisplayConfig">
        <wiz-hgroup target="header-title" width="100%">
          <wiz-label [wizLabel]="'$.vision.target.title.$'" class="titleLabel" [wizTextBehavior]="'truncate'" width="100%"></wiz-label>
        </wiz-hgroup>
      </multi-display>
    </wiz-vgroup>


  <!-- zone détail -->
  <wiz-group width="100%" height="100%" class="section-container-parent">

    <!-- lorsque rien n'est sélectionné -->
      <widget-renderer
      *ngIf="!isDetailVisible"
      class="view-widget"
      width="100%"
      [title]="'$.scenario.home.title.$'"
      [description]="'$.scenario.home.description.$'"
    ></widget-renderer>
  
    <!-- zone détail -->
    <wiz-vgroup wizValidationContainer #vgDetailZone 
    [visible]="isDetailVisible" width="100%" height="100%">
    
      <!-- titre, batch et save -->
      <wiz-hgroup width="100%" height="80px" class="section-container">
          <wiz-hgroup target="header-title" width="100%" verticalAlign="center">     
              <wiz-image #uploadImg height="40px" width="40px"></wiz-image>
              <wiz-label #lblTitle class="titleLabel"></wiz-label>
              <wiz-spacer width="20px"></wiz-spacer>
              <wiz-hgroup width="65px" height="28px">
                <wiz-icon [wizTooltip]="'$.export.scenario.$'" tooltipPlacement="left" class="image-purple" (click)="doAct('export')">download</wiz-icon>
                <wiz-icon [wizTooltip]="'$.import.scenario.$'" tooltipPlacement="left" class="image-purple" (click)="doAct('import')" >upload</wiz-icon>    
              </wiz-hgroup>
          </wiz-hgroup>
          <wiz-vgroup padding="3px" horizontalAlign="center" width="260px">
            <wiz-button #btnSave  [wizLabel]="'$.common.save.$'" [wizDisabled]="disableSave()"
            [wizIcon]="'arrow-right'" [iconPlacement]="'right'" width="240px"></wiz-button>
            <wiz-button
              #btnCancel [wizDisabled]="disableCancel()"
              class="cancel-button"
              [wizIcon]="'arrow-left'"
              [wizLabel]="'$.common.cancel.modification.$'"></wiz-button>
          </wiz-vgroup>
      </wiz-hgroup>


      <!-- tree de présentation des freedata values -->
      <wiz-hgroup width="100%" height="100%">

        <wiz-vgroup #vgTreeContainer width="100%" height="100%" class="section-container">   
          <wiz-hgroup verticalAlign="center">        
            <wiz-icon #btnAddScen [wizTooltip]="'$.scenario.add.$'" class="image-back-orange" 
            (click)="addFirstLevelScen()" [wizDisabled]="cantCreateValues">add</wiz-icon>
            <wiz-label class="titleLabel" [wizLabel]="'$.scenario.add.$'" [wizTextBehavior]="'truncate'" width="100%"></wiz-label>
          </wiz-hgroup>
          <wiz-tree #treeScen [actionsRenderer]="valuesTreeRenderer" width="100%"  height="100%">
          </wiz-tree>
          <!-- filtre du tree -->
          <filter-component #scenFilter width="250px"> </filter-component>
        </wiz-vgroup>

        <!--  zone de détail des scen -->
        <wiz-hgroup wizValidationContainer width="400px" [visible]="showScenEditZone" style="overflow: auto">
          <wiz-vgroup #vgEditValue wizValidationContainer width="100%" height="100%" padding="10px" class="section-container" >
              <wiz-label class="smallTitleLabel" [wizLabel]="'$.scen.values.title.$'"></wiz-label>
              <wiz-hgroup width="100%">
                <wiz-text-input #tiCode 
                  [wizLabel]="'$.common.code.$'"
                  class="upper-case-input"  
                  [wizFocusMode]="'STOP'"
                  [wizShowErrors]="true"
                  [wizMandatory]="true"
                  [wizValidator]="uniqueCodeValidator()"
                  width="100%"></wiz-text-input>

                  <wiz-vgroup width="100px">
                    <wiz-label wizLabel="$.scen.color.$" style="font-size: 11px"></wiz-label>
                    <wiz-hgroup verticalAlign="center">
                      <span
                        #blockBack
                        [style.backgroundColor]="backgroundColor"
                        width="20px"
                        height="20px"
                        (click)="showColorPicker($event)"
                        style="cursor: pointer; border-radius: 20px; border-style: solid; border-width: 1px"
                      ></span>
                      <wiz-icon style="cursor: pointer; font-size: 20px" (click)="resetColor('blockBack')">removal</wiz-icon>
                    </wiz-hgroup>
                  </wiz-vgroup>


              </wiz-hgroup>
        
              <wiz-translation-basic
                #trsLabel
                wizValidator
                [wizLabel]="'$.common.label.$'"
                width="100%"
                [wizShowErrors]="true"
                [wizMandatory]="true"
              ></wiz-translation-basic>
  
              <wiz-translation-basic
                #trsDesc
                [wizTranslationMode]="'textarea'"
                [wizLabel]="'$.common.description.$'"
                width="100%"
                height="100px"
              >
              </wiz-translation-basic>
  
              <wiz-label class="smallTitleLabel" [wizLabel]="'$.scen.param.bystep.$'"></wiz-label>
              
              <wiz-ag-grid id="stepList" width="100%" height="100%" 
                class="ag-theme-alpine"
                [wizDatasource]="stepParamDS" 
                [columnDefs]="stepColumns" 
                (cellClicked)="doStepConfiguration($event)">
              </wiz-ag-grid>
  
          </wiz-vgroup>


        </wiz-hgroup>


      </wiz-hgroup>

    </wiz-vgroup><!-- fin de la section détail -->
  </wiz-group>
</wiz-h-divider>
